<template>
<div>
 <v-toolbar dense class="secondary" >
    <v-toolbar-title style="color:white!important">Check Offers</v-toolbar-title>
    <v-spacer></v-spacer>
       <v-btn icon  @click="fetchoffers"><v-icon color="white">refresh</v-icon></v-btn>
  </v-toolbar>
      <v-data-table
      :headers="headers"
      :items="offerlist"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.key }}</td>
        <td >{{ props.item.name }}</td>
        <td >{{ props.item.offer }}</td>
      </template>      
    </v-data-table>


  <v-dialog v-model="dialog" persistent width="300"><v-card color="primary" dark><v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text></v-card></v-dialog>
</div>
</template>


<script>
export default {
   data(){
      return{
            headers: [
                { text: 'S No', value: 'sno',align: 'left',sortable: false, },
                { text: 'UPI ID', value: 'upi' },
                { text: 'Username', value: 'username' },
            ],
            dialog:false,
            offerlist:[]
      }
   },
   computed:{
      offers(){
         return this.$store.getters.offers;
      },
      user(){
         return this.$store.getters.user;
      }
   },
   watch:{
      offers(value){
            this.pushoffers(value)
      }            
   },
   methods:{
      notification(type,message){
        this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000, 
                type:type               
        })
      },
      pushoffers(value){
         let vm = this;
            vm.offerlist = []               
            let key = 1;
            for(let i =0;i<value.length;i++){
               vm.offerlist.push({
                  key:key,
                  name:value[i].Service,
                  offer:value[i].Offer
               })
               key++;
            }
      
      },
      fetchoffers(){
         let vm = this;
         if(!vm.user.phone) return vm.notification("warn","Authentication Required!");
         let doc = {
           'MobileNo':vm.user.phone,
           'Password':vm.user.password,
           'AuthKey':vm.user.authkey,
           'Source':'json'
           }
            vm.dialog = true;                    
            vm.$store.dispatch("axiospost",{
                  url:"Check_All_Offers",
                  data:doc,
            }).then(function (res) {
                  vm.dialog = false;            
                  vm.$store.commit("setoffers",res.data);
            }).catch(function (error) {
                  vm.notification("error",error);
                  vm.dialog = false;            
            })
   }
   },
   mounted(){
      let vm = this;
      if(vm.offers.length==0){
         vm.fetchoffers()    
      }else{
         vm.pushoffers(vm.offers)
      }
   }
}
</script>
